import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import http from 'http'

import parseSearchParams from 'fn/parseSearchParams'

const CardNumber = ( {
  url,
  title,
  units,
  ceil = false
} ) => {
  const [ searchParams, setSeachParams ] = useSearchParams()
  const [ n, setN ] = useState()

  useEffect( () => {
    const no = parseSearchParams( searchParams )

    http( {
      method: 'GET',
      url,
      params: {
        ...no
      }
    } )
      .then( ( { data } ) => {
        let { count } = data

        if ( ceil )
          count = Math.ceil( count )

        setN( count )
      } )
  }, [ searchParams ] )

  return <div className="one hs ai-center in-air-2x bg-secondary br">
    <div className="vs gap-2x air">
      <span>{ title }</span>
    </div>

    <span className="size-5x">
      { n }
    </span>

    <span className="size-3x">{ units }</span>
  </div>

}

export default CardNumber
